/*
 * @Author: Gaho
 * @Date: 2024-07-11 14:19:40
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-09 11:16:21
 * @Description: 
 */
import { useRatesStore } from '@/stores/cansino/rates';
import { accMultiple } from '@/pages/casino/plinkoGame/js/module';
import useSettingsStore from '@/stores/settings';
/**
 * 通过汇率将jackpot转换成当前所选货币
 * @param jackpot {Number} 奖池金额
 * return 转换后的奖池金额
 */
export const handleExchangeRate = (jackpot, currency = 'btc') => {
    const { comparisonCurrencyList } = useRatesStore();
    // 转换后的jackpot金额
    let currentJackpotSum = null;
    // btc转usdt汇率
    const btcToUsdt = comparisonCurrencyList[`${currency}usdt`];
    // usdt转cny汇率
    const usdtToCny = comparisonCurrencyList['usdtcny'];
    // usdt转eth汇率
    const usdtToEth = comparisonCurrencyList['usdteth'];
    // btc转usdt后的金额
    const currentUsdt = accMultiple(jackpot, btcToUsdt);
    switch(useSettingsStore().pickedCurrency){
        case 'btc': 
            currentJackpotSum = jackpot;
            break;
        case 'usdt': 
            currentJackpotSum = Number(currentUsdt);
            break;
        case 'cny':
            // usdt转cny
            currentJackpotSum = Number(accMultiple(currentUsdt, usdtToCny));
            break;
        case 'eth':
            // usdt转eth
            currentJackpotSum = Number(accMultiple(currentUsdt, usdtToEth));
            break;
        default: 
    }
    return currentJackpotSum;
}